import React, { useContext, useState } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import { confirmAlert } from "react-confirm-alert"
import { useSelector, useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"

import { logOut } from "@actions/loginActions"
import { loginProviders } from "@config/enums"
import { selectUserInfo } from "@selectors/user"
import { images } from "@utils/imageUtils"
import { SideBarContext } from "@utils/sideBarContext"
import { MEDIA_SIZES } from "assets/styles/mediaSizes"
import { canSeeViewToggle, getViewMode, setViewMode } from "@utils/viewMode"

import { NavItem } from "./molecules"
import { ListItem } from "./sidebarStyles"

import "./user-info-popover.scss"

const menuItems = [
  {
    name: "Profile",
    icon: "user-circle",
    pathname: "/my-profile",
    className: "user-info-popover__menu-icon",
  },
  {
    name: "Settings",
    icon: "menu-settings",
    className: "user-info-popover__menu-icon",
    pathname: "/settings",
  },
]

const UserInfoPopover = ({ onPopoverClose }) => {
  const { logout } = useAuth0()
  const { handleToggleSidebar } = useContext(SideBarContext)
  const userInfo = useSelector(selectUserInfo)
  const history = useHistory()
  const dispatch = useDispatch()
  // ticket #217: dev/user view toggle -- control only rendered for a minimal gate (dev backend
  // deploy or a small known-user allowlist); default is always USER even for gated users until
  // they flip it themselves.
  const [viewMode, setViewModeState] = useState(() => getViewMode())
  const showViewToggle = canSeeViewToggle(userInfo?.email)

  const redirectTo = nextPath => {
    history.push(nextPath)
    onPopoverClose()
    if (document.body.offsetWidth <= Number.parseInt(MEDIA_SIZES.MOBILE)) {
      handleToggleSidebar(false)
    }
  }

  const onLogout = () => {
    const { registrationType, loginType } = userInfo

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="react-confirm-alert-body"
            style={{ transform: "translateY(-50%)" }}>
            <img
              src={images.closeSettings}
              className="settings__modal__closeIcon"
              alt="close"
              onClick={onClose}
            />
            <h1>Logout</h1>
            Are you sure you want to logout?
            <div className="react-confirm-alert-button-group">
              <button onClick={onClose}>Cancel</button>
              <button
                onClick={() => {
                  onPopoverClose()

                  if (
                    (registrationType &&
                      registrationType !== loginProviders.email) ||
                    (loginType && loginType !== loginProviders.email)
                  ) {
                    dispatch(logOut(logout))
                  } else dispatch(logOut())
                  onClose()
                }}>
                Logout
              </button>
            </div>
          </div>
        )
      },
    })
  }

  return (
    <div>
      <div className="user-info-popover">
        <div className="user-info-popover__avatar">
          <img src={userInfo.avatar} alt="avatar" />
        </div>
        <div className="user-info-popover__info">
          <p className="user-info-popover__name">{userInfo.name}</p>
          {/* wave4-fix7: only render the handle line when a real handle exists (dev
              backend has no username field; a bare "@" rendered before) */}
          {userInfo.nickname && (
            <p className="user-info-popover__nickname">@{userInfo.nickname}</p>
          )}
        </div>
      </div>

      {menuItems.map(item => (
        <ListItem
          $isClickable
          $isWrapped={false}
          key={item.pathname}
          onClick={() => redirectTo(item.pathname)}>
          <NavItem staticElement isActive={false} item={item} />
        </ListItem>
      ))}

      {showViewToggle && (
        <div
          className="user-info-popover__view-toggle"
          data-testid="dev-user-view-toggle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 16px",
            borderTop: "1px solid #eee",
            borderBottom: "1px solid #eee",
          }}>
          <span style={{ fontSize: 12, color: "#404040" }}>
            {viewMode === "dev" ? "Dev view" : "User view"}
          </span>
          <button
            type="button"
            data-testid="dev-user-view-toggle-btn"
            onClick={() => {
              const next = viewMode === "dev" ? "user" : "dev"
              setViewMode(next)
              setViewModeState(next)
            }}
            style={{
              border: "1px solid #7FB1E3",
              borderRadius: 12,
              background: viewMode === "dev" ? "#7FB1E3" : "#fff",
              color: viewMode === "dev" ? "#fff" : "#7FB1E3",
              fontSize: 11,
              padding: "3px 10px",
              cursor: "pointer",
            }}>
            {viewMode === "dev" ? "Switch to User" : "Switch to Dev"}
          </button>
        </div>
      )}

      <div className="user-info-popover__logout" onClick={onLogout}>
        <p className="user-info-popover__logout_action">Log out</p>
      </div>
    </div>
  )
}

export default UserInfoPopover
